import React from "react";
import PropTypes from "prop-types";
import Heading from "../../elements/heading";
import PreviewRow from "../../elements/preview-row";
import PrimaryLink from "../../elements/primary-link";
import "./style.scss";

export default function FormOverviewSection({ heading, items, button }) {
  return (
    <div className="form-overview-section">
      {items.length > 0 && heading?.type && heading?.html && (
        <div className="form-overview-section-heading">
          <Heading type={heading.type} html={heading.html} typographyClass={"type-h3"} />
        </div>
      )}

      <div className="form-overview-section-fields">
        {items.map(item => (
          <PreviewRow key={item.label} label={item.label} value={item.value} />
        ))}
      </div>
      {button && items.length > 0 && (
        <div className="form-overview-section-button">
          <PrimaryLink {...button} />
        </div>
      )}
    </div>
  );
}

FormOverviewSection.propTypes = {
  heading: PropTypes.shape({
    type: PropTypes.object,
    html: PropTypes.object
  }),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    })
  ),
  button: PropTypes.object
};
